import gql from 'graphql-tag'

export const eventCodeDelete = gql`
  mutation eventCodeDelete($eventCodeId: ID!) {
    eventCodeDelete(input: { eventCodeId: $eventCodeId }) {
      success
    }
  }
`
